(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Adds 'Back to top' functionality to an element with the ID 'back-to-top'
 * @example 
 * 1. Create a link-wrapper with ID 'back-to-top'
 * 2. Add an icon inside the link-wrapper such as an arrow
 * 3. Set position fixed: bottom right
 * 4. Set opacity to 0
 */

class BackToTop {
  constructor() {
    this.$backToTop = $('.back-to-top-wrapper');
    this.toggleDistance = 500;
    if (this.$backToTop.length > 0) {
      this.init();
    }
  }
  init() {
    this.lastScrollTop = 0;
    this.header = document.getElementsByTagName('header')[0];
    this.adminBar = document.getElementById('wpadminbar');
    if (this.adminBar) {
      this.adminBarHeight = this.adminBar.getBoundingClientRect().height;
    } else {
      this.adminBarHeight = 0;
    }
    // this.headerHeight = this.header.getBoundingClientRect().height;
    this.headerHeight = 0;
    window.onscroll = () => this.scrollFunction();
    this.$backToTop.find('a').on('click', e => {
      e.preventDefault();
      window.scrollTo(0, 0);
    });
  }
  scrollFunction() {
    this.scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.scrollingUp = this.scrollTop < this.lastScrollTop;
    if (this.adminBar) {
      this.adminBarHeight = this.adminBar.getBoundingClientRect().height;
    }
    // this.headerHeight = this.header.getBoundingClientRect().height;
    this.headerHeight = 0;
    this.backToTopOffset = this.headerHeight + this.adminBarHeight;
    if (this.scrollTop > this.toggleDistance && this.scrollingUp) {
      this.$backToTop.addClass('active');
      this.$backToTop.css('top', this.backToTopOffset);
    } else {
      this.$backToTop.removeClass('active');
      this.$backToTop.css('top', 0);
    }
    this.lastScrollTop = this.scrollTop <= 0 ? 0 : this.scrollTop;
  }
}
var _default = BackToTop;
exports.default = _default;

},{}],2:[function(require,module,exports){
"use strict";

var _backToTop = _interopRequireDefault(require("./modules/back-to-top"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Manage global libraries like jQuery or THREE from the package.json file
 */

window.$ = jQuery;

// import BackToTop from './modules/back-to-top';
// import SocialSharePopups from './modules/social-share-popups';

$(document).ready(function () {
  $('html').addClass('js-on-load');
  const backToTop = new _backToTop.default();
  // const backToTop = new BackToTop();
  // const socialSharePopups = new SocialSharePopups();

  // plugin('ResponsiveTabs', ResponsiveTabs);
});

},{"./modules/back-to-top":1}]},{},[2]);
